module.exports = __webpack_public_path__ + "img/1c.ef5509d8.svg";